/**
 * Garden Object Categories
 *
 * Defines the 5 main categories for organizing garden objects
 */

export const GARDEN_OBJECT_CATEGORIES = {
  STRUKTUREN: 'strukturen',
  GEBAEUDE: 'gebaeude',
  PFLANZFLAECHEN: 'pflanzflaechen',
  WASSER: 'wasser',
  SONSTIGES: 'sonstiges',
};

export const CATEGORY_DEFINITIONS = {
  [GARDEN_OBJECT_CATEGORIES.STRUKTUREN]: {
    id: 'strukturen',
    name: 'Strukturen',
    description: 'Wege, Mauern, Zäune, Tore, Rasenkanten',
    icon: 'Fence',
    order: 1,
  },
  [GARDEN_OBJECT_CATEGORIES.GEBAEUDE]: {
    id: 'gebaeude',
    name: 'Gebäude',
    description: 'Gebäude, Gewächshäuser',
    icon: 'Home',
    order: 2,
  },
  [GARDEN_OBJECT_CATEGORIES.PFLANZFLAECHEN]: {
    id: 'pflanzflaechen',
    name: 'Pflanzflächen',
    description: 'Beete, Hochbeete, Rasen, Blumenkästen, Blumenampeln, Töpfe',
    icon: 'Sprout',
    order: 3,
  },
  [GARDEN_OBJECT_CATEGORIES.WASSER]: {
    id: 'wasser',
    name: 'Wasser',
    description: 'Teiche, Wasserflächen',
    icon: 'Droplet',
    order: 4,
  },
  [GARDEN_OBJECT_CATEGORIES.SONSTIGES]: {
    id: 'sonstiges',
    name: 'Sonstiges',
    description: 'Kompost, Terrassen, weitere Objekte',
    icon: 'MoreHorizontal',
    order: 5,
  },
};

/**
 * Get category definition by ID
 */
export const getCategoryById = (categoryId) => {
  return CATEGORY_DEFINITIONS[categoryId] || null;
};

/**
 * Get all categories sorted by order
 */
export const getAllCategories = () => {
  return Object.values(CATEGORY_DEFINITIONS).sort((a, b) => a.order - b.order);
};

/**
 * Get category name by ID
 */
export const getCategoryName = (categoryId) => {
  const category = getCategoryById(categoryId);
  return category ? category.name : 'Unbekannt';
};
